import http from "../../http";

export const foldersTemplateServices = {
    getTemplateFoldersService,
    getAllChildFoldersService,
    createNewFolderService,
    deleteFolderService,
    renameFolderService
}

function getTemplateFoldersService() {
    return http.get(`${process.env.REACT_APP_BASE_URL}/folder-template/`);
}

function getAllChildFoldersService(payload: any) {
    return http.get(`${process.env.REACT_APP_BASE_URL}/folder-template/${payload?.folderId}`);
}

// create new folder service
function createNewFolderService(payload: any) {
    return http.post(`${process.env.REACT_APP_BASE_URL}/folder-template/`, payload?.body);
}

// delete folder service
function deleteFolderService(payload: any) {
    return http.delete(`${process.env.REACT_APP_BASE_URL}/folder-template/${payload?.folderId}`);
}

// rename folder service
function renameFolderService(payload: any) {
    return http.put(`${process.env.REACT_APP_BASE_URL}/folder-template/${payload?.folderId}`, payload?.body);
}